import { render, staticRenderFns } from "./my-member-upgrade.vue?vue&type=template&id=0a15bf2e&"
import script from "./my-member-upgrade.vue?vue&type=script&lang=js&"
export * from "./my-member-upgrade.vue?vue&type=script&lang=js&"
import style0 from "./my-member-upgrade.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports